import {useTheme} from "@mui/material";
import {useCallback} from "react";
import {color_blue, color_orange, color_yellow} from "@/agentur/AgenturColors";

export const useCardChangeColors = () => {
    const theme = useTheme();
    const darkMode = theme.palette.mode === "dark";

    const getGridChangeSx = useCallback(
        (shall: any, changed: any) => {
            const sxChanged = {
                backgroundColor: darkMode ? color_blue[2] : color_yellow[3],
                padding: "8px 8px",
                marginTop: "-8px",
                borderRadius: 2
            };

            const sxChangeable = {
                backgroundColor: darkMode ? color_blue[0] : color_yellow[4],
                padding: "8px 8px",
                marginTop: "-8px",
                borderRadius: 2
            };

            if (shall && changed) {
                return sxChanged;
            } else if (shall) {
                return sxChangeable;
            }

            return undefined;
        },
        [darkMode]
    );

    const getCheckboxChangeSx = useCallback(
        (shall: any, changed: any) => {
            const sxChanged = {
                backgroundColor: darkMode ? color_blue[2] : color_orange[2],
                paddingLeft: 1,
                borderRadius: 2
            };

            const sxChangeable = {
                backgroundColor: darkMode ? color_blue[0] : color_yellow[4],
                paddingLeft: 1,
                borderRadius: 2
            };

            if (shall && changed) {
                return sxChanged;
            } else if (shall) {
                return sxChangeable;
            }
            return undefined;
        },
        [darkMode]
    );

    return { getGridChangeSx, getCheckboxChangeSx };
};
